<div class="rfq-tab" id="rfq-tab" *ngIf="showTab; else loading">
  <div class="rfq-tab__controller">
    <div class="rfq-tab__controller__legs-container">
      <div
        class="rfq-tab__controller__legs-container__attributes"
        id="legAttribute"
      >
        <active-attributes
          [rfqExecution]="true"
          [legs]="nestedLegs"
        ></active-attributes>
      </div>
      <div class="rfq-tab__controller__legs-container__legs scrollable-content">
        <app-leg
          *ngFor="let leg of legs; index as i"
          [legIndex]="i"
          [leg]="leg.leg.leg"
          (legPresetLoaded)="onLegPresetLoaded(i)"
          (fieldBlurred)="changeInLeg()"
          [legSyncingInfo]="legSyncingInfo"
          [rfqExecutionSettings]="rfqLegSettings"
        ></app-leg>
      </div>
    </div>
    <div class="rfq-tab__controller__setup">
      <app-provider-quote-setup
        #setup
        [quoteEvent]="tabItem?.fullQuote"
        [cross]="cross"
        [isPremiumBasedVanillasWithSpotFeed]="
          tabItem.isPremiumBasedVanillasWithSpotFeed
        "
        [rfqDetails]="rfqDetails"
        [volBasedRfqOptionPriceResult]="volBasedRfqOptionPriceResult"
        [form]="setupForm"
        [tabItem]="tabItem"
        [showExpiryDate]="showExpiryDate"
        [streamedHedge]="tabItem.streamedHedge"
        (changeInSetupForm)="changeInSetupForm()"
      ></app-provider-quote-setup>
    </div>
  </div>
  <ng-container *ngTemplateOutlet="commentTmpl"></ng-container>
  <div class="rfq-tab__prices">
    <app-provider-quote-prices
      [quoteEvent]="tabItem?.fullQuote"
      [volBasedRfqOptionPriceResult]="volBasedRfqOptionPriceResult"
      [pricesLoading]="pricesLoading"
      [initialPrice]="initialPrice"
      [legs]="tabItem?.legs"
      [setupForm]="setupForm"
      [executionContext]="tabItem.executionContext"
      [isVolBased]="tabItem.isVolBased"
      [isPremiumBasedVanillasWithSpotFeed]="
        tabItem.isPremiumBasedVanillasWithSpotFeed
      "
      [forwardPointsMultiplier]="forwardPointsMultiplier"
      [rfqDetails]="rfqDetails"
      [pipsHighlightedIndices]="pipsHighlightedIndices"
      (closeTab)="doCloseTab()"
      (quoteEventActionChange)="quoteEventActionChange($event)"
    ></app-provider-quote-prices>
  </div>
</div>

<ng-template #loading>
  <div
    class="spinner-container"
    *ngIf="!failedExecutionContext; else getExecutionContextFailed"
  >
    <span class="spinner spinner-md spinner-inverse"> </span>
  </div>

  <ng-template #getExecutionContextFailed>
    <div class="execution-context-failed">
      Failed to get the execution context
    </div>
  </ng-template>
</ng-template>

<!-- COMMENT -------------------------------------------------->

<ng-template #commentTmpl>
  <div class="alert alert-info alert-sm" role="alert" *ngIf="rfqComment">
    <div class="alert-items">
      <div class="alert-item static">
        <div class="alert-icon-wrapper">
          <cds-icon class="alert-icon" shape="chat-bubble"></cds-icon>
        </div>
        <span class="alert-text">
          {{ rfqComment }}
        </span>
      </div>
    </div>
  </div>
</ng-template>
